export const BRAND = {
  name: "Hoorecars",
  domain: "Hoorecars.com",
  legalName: "Friends Fleet Management Private Limited",
  email: "support@hoorecars.com",
  phone: "+91 72045 07760",
  address: "No. 50, Khata No. 2674/130/50, Rayasamdra Village, Huskur, Anekal Taluk, Bengaluru Urban, Karnataka 560099",
  city: "Bengaluru",
  state: "Karnataka",
  gstin: "29AAHCF3006F1ZW",
  cin: "U77100KA2026PTC229519",
  incorporated: "9 October 2026",
  directors: ["Selvam Kadiravan", "Sundemurthy Ranjeeth"],
  grievanceOfficer: "Kadiravan",
  grievanceEmail: "grievance@hoorecars.com",
  hours: "9:00 AM – 9:00 PM IST, all days",
  effectiveDate: "1 November 2026",
  legalVersion: "2.0",
  developer: { name: "Velactra", url: "https://velactra.com/" },
};

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a1d06238-81b3-418e-b7a6-a44b3ed116b2/images/4911e2f65017194910eb3cd722c19ebaf42d8d23015f33fe02b0a735c663c300.jpeg";
export const HOST_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a1d06238-81b3-418e-b7a6-a44b3ed116b2/images/db625139b873c3e4a1cc9df0d20662ca1713a832f1d2088aee2a5d3a2462cdf2.jpeg";
export const DRIVER_PER_DAY = 1299;
export const CAR_TYPES = [
  { type: "Hatchback", label: "Hatchbacks" },
  { type: "Sedan", label: "Sedans" },
  { type: "SUV", label: "SUVs" },
  { type: "MUV", label: "MUVs (7 Seater)" },
  { type: "Off-road", label: "4x4 Off-road" },
];

export const inr = (n) => `${n < 0 ? "−" : ""}₹${Math.abs(Number(n || 0)).toLocaleString("en-IN")}`;

const withTz = (s) => (/[zZ]|[+-]\d\d:\d\d$/.test(s) ? s : `${s.length === 16 ? `${s}:00` : s}+05:30`);

export const fmtDT = (iso) =>
  iso ? new Date(withTz(iso)).toLocaleString("en-IN", { timeZone: "Asia/Kolkata", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }) : "";

const pad = (n) => String(n).padStart(2, "0");
const toLocal = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;

export function defaultDates() {
  const p = new Date();
  p.setDate(p.getDate() + 1);
  p.setHours(10, 0, 0, 0);
  const r = new Date(p);
  r.setDate(r.getDate() + 2);
  return { pickup: toLocal(p), ret: toLocal(r) };
}

export const ANGLES = [
  { key: "front", label: "Front", short: "Front" },
  { key: "back", label: "Back", short: "Back" },
  { key: "driver", label: "Driver side", short: "Driver" },
  { key: "passenger", label: "Passenger side", short: "Passenger" },
  { key: "interior", label: "Interior", short: "Interior" },
];

export const STATUS_STYLE = {
  PENDING_PAYMENT: "bg-amber-100 text-amber-800 border-amber-200",
  CONFIRMED: "bg-emerald-100 text-emerald-800 border-emerald-200",
  ACTIVE: "bg-sky-100 text-sky-800 border-sky-200",
  COMPLETED: "bg-neutral-200 text-neutral-800 border-neutral-300",
  CANCELLED: "bg-rose-100 text-rose-800 border-rose-200",
};

export const statusLabel = (s) => (s || "").replace("_", " ").toLowerCase().replace(/^\w/, (c) => c.toUpperCase());
